import { useIntlLocale } from "@frontend/hooks/useIntlLocale";
import { useLingui } from "@lingui/react/macro";

import type { RouteSummary } from "../types";

// "40.8 km, 37 min" from a route, in the reader's locale.
export function useRouteText(): (route: RouteSummary) => string {
  const { t } = useLingui();
  const locale = useIntlLocale();

  return (route) => {
    const distance =
      route.distanceMeters < 1000
        ? new Intl.NumberFormat(locale, {
            style: "unit",
            unit: "meter",
            maximumFractionDigits: 0,
          }).format(route.distanceMeters)
        : new Intl.NumberFormat(locale, {
            style: "unit",
            unit: "kilometer",
            maximumFractionDigits: 1,
          }).format(route.distanceMeters / 1000);

    const minutes = Math.round(route.durationSeconds / 60);
    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;

    const duration = hours > 0 ? t`${hours} h ${rest} min` : t`${minutes} min`;

    return t`${distance}, ${duration}`;
  };
}
